import { render, staticRenderFns } from "./DynamicView.vue?vue&type=template&id=3df99ee4"
import script from "./DynamicView.vue?vue&type=script&lang=js"
export * from "./DynamicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports